import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { TbIllustration } from 'components/Figma';

export function NoTokensAvailable() {
  return (
    <Box className="flex flex-row items-center justify-center py-8">
      <TbIllustration name="EmptyState" size="sm" className="mr-6" />
      <Typography variant="body1" sx={{ fontWeight: 700 }}>
        <FormattedMessage id="api_access.token.no_active_tokens" />
      </Typography>
    </Box>
  );
}
